import { render, staticRenderFns } from "./Commercial.vue?vue&type=template&id=5c6331b1&scoped=true"
import script from "./Commercial.vue?vue&type=script&lang=js"
export * from "./Commercial.vue?vue&type=script&lang=js"
import style0 from "./Commercial.vue?vue&type=style&index=0&id=5c6331b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6331b1",
  null
  
)

export default component.exports